// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --theme-agnostic-base-white: #fff;\n  --theme-agnostic-border-grey: #ddd;\n  --theme-agnostic-legal-deadline-renewed: #32a9f5;\n  --theme-agnostic-light-grey: #ececec;\n  --theme-agnostic-dark-grey: #4a4a4a;\n  --theme-agnostic-medium-grey: #999;\n}\n", ""]);
// Exports
module.exports = exports;
